import { formatFileSize } from 'helpers';
import { TFunc } from 'libs/i18n';
import { Typography } from 'libs/ui';

export const renderSize = (size: number, t: TFunc) => (
  <Typography>{formatFileSize(size, t)}</Typography>
);
